module.exports = __webpack_public_path__ + "img/main_footer_bg.cafde68.webp";